import BodyText from "components/BodyText";
import { RedButton } from "components/Button";
import Heading from "components/Heading";
import { useConfig } from "providers/ConfigContext";
import React from "react";
import styled from "styled-components";

const ShareTheFairComponent = () => {
	const { damAssetsOrigin, contributeToFairOrigin } = useConfig();

	return (
		<OuterContainer>
			<InnerContainer>
				<LeftContainer>
					<StyledSchooolImage
						src={`${damAssetsOrigin}LiveHomepage/ShopOnline/SHARE_THE_FAIR.png`}
						alt="School!"
					/>
				</LeftContainer>
				<RightContainer>
					<StyledHeading>
						LEFTOVER BOOK FAIR eWALLET FUNDS?
					</StyledHeading>
					<StyledBody>
						If you have extra Book Fair eWallet funds that converted
						to an eGift Card balance, consider contributing to Share
						the Fair, the giving program that benefits students at
						your school who need help buying new books.
					</StyledBody>
					<StyledRedButton
						handleClick={(e) =>
							window.open(
								`${contributeToFairOrigin}/my-scholastic/profile/gift-card.html?contribute=1`,
								"noopener noreferrer"
							)
						}
					>
						Contribute Today
					</StyledRedButton>
				</RightContainer>
			</InnerContainer>
		</OuterContainer>
	);
};

const OuterContainer = styled.div`
	background-color: #ffffff;
	width: 100%;
`;

const InnerContainer = styled.div`
	display: flex;
	justify-content: center;
	gap: 100px;
	margin: 48px 0px;
	@media (max-width: 1100px) {
		gap: 35px;
		margin: 75px 0px;
	}
	@media (max-width: 685px) {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0px;
		margin: 24px 0px;
	}
`;

const LeftContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;

const RightContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	@media (max-width: 1100px) {
		max-width: 322px;
	}
`;

const StyledSchooolImage = styled.img`
	display: flex;
	width: 100%;
	max-height: 254.5px;
	max-width: 349.5px;
	margin: 19px 0px 46px 0px;
	@media (max-width: 1100px) {
		max-height: 201px;
		padding: 0px;
	}
	@media (max-width: 685px) {
		max-height: 185px;
	}
`;

const StyledRedButton = styled(RedButton)`
	margin-top: 32px;
	width: 193px;
`;

const StyledHeading = styled(Heading)`
	display: flex;
	font-size: 32px;
	font-style: normal;
	font-weight: 600;
	line-height: 35px;
	letter-spacing: 1px;
	text-align: center;
	max-width: 440px;
	color: #333;
	@media (max-width: 1100px) {
		font-size: 32px;
		line-height: 35px;
	}
`;

const StyledBody = styled(BodyText)`
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 19px;
	letter-spacing: 0px;
	text-align: center;
	max-width: 453px;
	@media (max-width: 375px) {
		font-style: normal;
		font-weight: normal;
		font-size: 16px;
		line-height: 19px;
		width: 325px;
		margin-bottom: 21px 0 31px 0;
	}
`;

export default ShareTheFairComponent;
